import { render, staticRenderFns } from "./changePass.vue?vue&type=template&id=0e37c516&scoped=true"
import script from "./changePass.vue?vue&type=script&lang=js"
export * from "./changePass.vue?vue&type=script&lang=js"
import style0 from "./changePass.vue?vue&type=style&index=0&id=0e37c516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e37c516",
  null
  
)

export default component.exports